import * as pdfjs from 'pdfjs-dist/build/pdf.mjs';
import workerUrl from 'pdfjs-dist/build/pdf.worker.mjs?url';

pdfjs.GlobalWorkerOptions.workerSrc = workerUrl;

const thumbCache = new Map();

export async function loadPdfDocument(bytes) {
  const data = bytes.slice(0);
  const task = pdfjs.getDocument({ data });
  return await task.promise;
}

export async function renderThumbnail(doc, originalPageIndex, scale = 0.4, rotation = 0) {
  const key = `${doc.fingerprints?.[0] || 'doc'}:${originalPageIndex}:${scale}:${rotation}`;
  const cached = thumbCache.get(key);
  if (cached) return cached;

  const page = await doc.getPage(originalPageIndex + 1);
  const viewport = page.getViewport({ scale, rotation });
  const canvas = document.createElement('canvas');
  canvas.width = Math.ceil(viewport.width);
  canvas.height = Math.ceil(viewport.height);
  const ctx = canvas.getContext('2d', { alpha: false });
  await page.render({ canvasContext: ctx, viewport }).promise;
  const url = canvas.toDataURL('image/jpeg', 0.82);
  thumbCache.set(key, url);
  return url;
}

export function clearThumbCache() {
  thumbCache.clear();
}
